import React from 'react';
import { Container } from 'src/design/atoms/Container';
import { Group } from 'src/design/atoms/Group';
import { Text } from 'src/design/atoms/Text';
import { useMediaQuery } from '@mantine/hooks';

const AuthFooter = () => {
  const matchDownSM = useMediaQuery('(max-width: 768px)');

  return (
    <Container size="xl">
      <Group justify={matchDownSM ? 'center' : 'space-between'}>
        <Text size="sm" c="dimmed">
          &copy; Firetrol Insite
        </Text>
      </Group>
    </Container>
  );
};

export default AuthFooter;
